module.exports = __webpack_public_path__ + "static/media/WBN_PLATINUM.b2d35059.svg";